<template>
    <div :class="wrapperClasses" style="vertical-align: middle;" @click="showPopover">
        <div v-if="value">
            <div class="bs-dot" :style="{ backgroundColor: value[keys.colour]}"></div>
            <div style="vertical-align: middle; font-size: 16px; display: inline-block; font-weight: bold;">{{ value[keys.label]}}</div>
        </div>
        <div v-else>
            Select...
        </div>

        <ui-popover open-on="manual" ref="popover">
            <div  style="position: relative;">
                <a v-for="opt in options" class="selector-option" href="#" @click.prevent="input(opt)" >
                    <div class="bs-dot" :style="{ backgroundColor: opt[keys.colour] }"></div> {{ opt[keys.label] }}
                </a>
            </div>
        </ui-popover>
    </div>
</template>

<script>
    export default {
        props: {
            options: {
                type: Array,
                required: true
            },
            value: {
                type: Object
            },
            keys: {
                type: Object,
                default() {
                    return {
                        colour: 'colour',
                        label: 'label',
                    }
                }
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            input(opt) {
                this.$emit('input', opt)

                this.$refs.popover.close()
            },
            showPopover() {
                if (!this.disabled) {
                    this.$refs.popover.toggle()
                }
            }
        },
        computed: {
            wrapperClasses() {
                let classes = ['keen-control-wrapper']

                if (this.disabled) {
                    classes.push('disabled')
                }

                return classes
            }
        }
    }
</script>

<style lang="scss" scoped>
    .bs-dot {
        margin-right: .25rem;
        vertical-align: middle;
        height: 16px; width: 16px;
        background: #999;
        border-radius: 50%;
        display: inline-block;
    }

    .selector-option {
        display: block;
        color: #212529 !important;
        padding: .5rem 1.5rem .5rem 1rem;

        &:link { text-decoration: none; }
    }
</style>